import { render, staticRenderFns } from "./CTABlockWidget.vue?vue&type=template&id=08c4b411&"
import script from "./CTABlockWidget.vue?vue&type=script&lang=js&"
export * from "./CTABlockWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c4b411')) {
      api.createRecord('08c4b411', component.options)
    } else {
      api.reload('08c4b411', component.options)
    }
    module.hot.accept("./CTABlockWidget.vue?vue&type=template&id=08c4b411&", function () {
      api.rerender('08c4b411', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/CTABlockWidget.vue"
export default component.exports